let ListManager = {
      TextSize: "Medium",
      ScreenOnOff: "On",
      Aggregate: "Open",
      AggregateHeight: "100",
      QuickQuote: "Open"
    };

export default ListManager;
